export default {
  section: 'Impuestos',
  loading: 'Cargando impuestos...',
  headers: {
    alias: 'Alias',
    kind: 'Impuesto',
    isRetention: 'Traslado o Retenido',
    isQuota: '¿Es tasa o cuota?',
    base: 'Valor de la tasa o cuota',
    baseAmount: 'Base del impuesto',
    action: 'Acciones'
  }
}
